import React, { Component } from 'react';

import { ILoanAccountActivity } from '../../../interfaces';
import { FormattingUtils } from '../../../utils';

import LoanAccountActivity from './LoanAccountActivity';

const { formatDate, formatMoney } = FormattingUtils;

interface IProps {
  activity: ILoanAccountActivity;
}

/**
 * Recorded by the nightly job when a compliance charge goes unpaid past its due date. The status it
 * set can be changed back by hand on the Details tab; this entry stays either way, as the record of
 * why it happened.
 */
class AccountMarkedDelinquent extends Component<IProps> {
  public render () {
    const { data } = this.props.activity
      , activityBody = (
        <div>
          <h3>Account Marked Delinquent</h3>
          <p><span className='status'>Compliance Charge Due:</span> {formatDate(data.due_date)}</p>
          <p><span className='status'>Outstanding:</span> {formatMoney(data.amount_outstanding)}</p>
        </div>
      )
      ;

    // Passed explicitly rather than spread: a spread would let a prop added upstream override the
    // dot and icon this component picked, and the failure would be a wrong icon rather than an error.
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='exclamation-triangle'
      />
    );
  }
}

export default AccountMarkedDelinquent;
